export type GoalPlanningWizardStep = 'connect' | 'financial' | 'goals' | 'interests';

export const GOAL_PLANNING_WIZARD_STEPS: GoalPlanningWizardStep[] = [
  'connect',
  'financial',
  'goals',
  'interests',
];

export const GOAL_PLANNING_INTEREST_IDS = [
  'savings',
  'investing',
  'retirement',
  'debt',
  'lifestyle',
  'education',
] as const;

export type GoalPlanningInterestId = (typeof GOAL_PLANNING_INTEREST_IDS)[number];
